
































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Pile} from '@/models';

import storePile from '@/stores/modules/pile';

import InputPhone from '@/components/Input/Phone.vue';

@Component({
	components: {
		InputPhone,
	}
})
export default class CrudPileEdit extends AbstractEditVue<Pile> {
	public constructor() {
		super(
			storePile,
			'Pile de déchargement modifié',
			'Pile de déchargement créé',
		);
	}
}
